import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useDebouncedCallback } from 'use-debounce';

import LoaderComponent from '@components/LoaderComponent';

import Product from '@features/trend-research/components/common/Product';
import ProductTopSection from '@features/trend-research/components/common/ProductTopSection';
import {
	getMultiplyWith,
	getSearchValueForSimilarProducts,
	sourceType
} from '@features/trend-research/utils/utils';
import { useFetchTrendExploreProductsMutation } from '@features/trend-research/api/onboardingApi';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';

import { isPageReachBottom } from '@utils/Util';

const SimilarProducts = () => {
	const dispatch = useDispatch();
	const [similarProducts, setSimilarProducts] = useState([]);
	const [totalElement, seTotalElement] = useState(0);
	const [page, setPage] = useState(0);
	const selectedItem = JSON.parse(sessionStorage.getItem('selectedItem')) || {};
	const [fetchTrendExploreProducts, { data, isLoading }] = useFetchTrendExploreProductsMutation();

	const debounce = useDebouncedCallback((offset) => {
		const source = sourceType[selectedItem?.source];
		const search = source === 'BRAND' ? getSearchValueForSimilarProducts(selectedItem) : null;
		fetchTrendExploreProducts({
			source: source,
			queryParams: `?page=${offset}&size=40${search ? '&k=500' : ''}`,
			requestBody: {
				categoryIdList: selectedItem?.categoryId ? [selectedItem.categoryId] : [],
				search: search
			}
		});
	}, 100);

	useEffect(() => {
		setSimilarProducts((prevProducts) => [...prevProducts, ...(data?.data || [])]);
		seTotalElement(data?.totalElements || 0);
	}, [data]);

	const fetchProducts = async (offset = 0) => {
		try {
			if (!selectedItem?.source) {
				return;
			}
			dispatch(openLoader());
			debounce(offset);
			dispatch(closeLoader());
		} catch {
			dispatch(closeLoader());
		}
	};

	useEffect(() => {
		fetchProducts(page);
	}, [page]);

	const handleScroll = useDebouncedCallback(() => {
		if (isPageReachBottom() && !isLoading && data?.currentPage + 1 < data?.totalPages) {
			setPage((prev) => prev + 1);
		}
	}, 100);

	useEffect(() => {
		window.addEventListener('scroll', handleScroll);
		return () => window.removeEventListener('scroll', handleScroll);
	}, []);

	return (
		<LoaderComponent loading={isLoading}>
			<div className="top-header ">
				{/* <!-- Filter Contanier top--> */}
				<div className="trend-list">
					<div className="page-title-area pb-2 d-flex align-items-center">
						<div className="d-flex">
							<h1 className="semibold-16">Similar styles</h1>
						</div>
					</div>
				</div>
			</div>
			{/* <!--Data container --> */}
			<section className="trend-data-container bg-white">
				<div className="similar-category-section">
					<div
						className="similar-product-box d-flex align-items-center align-self-center"
						style={{
							minWidth: `${
								300 + selectedItem?.name?.length * getMultiplyWith(selectedItem?.name?.length)
							}px`
						}}
					>
						<div className="img">
							<img
								src={
									selectedItem?.imageUrl ||
									`${process.env.PUBLIC_URL}/images/trend/demo.jpg`
								}
								alt=""
							/>
						</div>
						<div className="similar-content ml-12">
							<p className="gray_dark_01 regular-14 weight-500 p-0">{selectedItem?.name}</p>
							<ul className="common-list-component mt-1">
								<li className="gray_dark_01 regular-14 weight-500">
									{selectedItem?.brandName || ''}
								</li>
								<li className="gray_dark_01 regular-14 weight-500">{selectedItem?.market}</li>
							</ul>
							<p className="ray_dark_01 regular-12 p-0">Related Products</p>
						</div>
					</div>
				</div>
				{/* <!-- trend-product --> */}
				<div className="trending-product border-0 top-fabric-product">
					<ProductTopSection
						title={`Similar Products(${totalElement})`}
						sourceType={selectedItem?.source}
					/>
					<Product allProducts={similarProducts} selectedItem={selectedItem} />
				</div>
			</section>
		</LoaderComponent>
	);
};

export default SimilarProducts;
